<template>
    <div style="width: 100%;height:100%;background: #F9FCFF;">
        <navbar></navbar>
        <div class="personal">
            <div class="box-header">
                <h1 class="box-title">{{$t('personal_center')}}</h1>
                <a href="javascript:;" class="box-button" @click="logOut">{{$t('sign_out')}}</a>
            </div>
            <modal v-model="modalStatus"></modal>
            <div class="tabs">
                <ul>
                    <li v-for="(item,index) in tabs">
                        <router-link :to="item.to" active-class="active">{{item.name}}</router-link>
                    </li>
                </ul>
                <div class="tabs-content">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import navbar from '../Common/Navbar.vue'
    import modal from '../Common/Modal.vue'

    export default {
        data () {
            return {
                modalStatus: false,
                tabs: [
                    {name: this.$t('user_center_title_Profile'), to: {name: 'Profile'}},
                    {name: this.$t('user_center_order'), to: {name: 'Order'}},
                    {name: this.$t('user_center_iPoint'), to: {name: 'iPoint'}},
                    {name: this.$t('user_center_Coupons'), to: {name: 'Coupons'}},
                    {name: 'iAPP', to: {name: 'iAPP'}}
                ],
                flag: 0,
                currentTab: 'profile'
            }
        },
        components: {
            navbar, modal
        },
        created () {
            this.$busEvent.$on('goToiAPP', function () {
                this.currentTab = 'iapp'
                this.flag = 4
            }.bind(this))

            this.$busEvent.$on('goToToUp', function () {
                this.currentTab = 'coupons'
                this.flag = 3
            }.bind(this))
        },
        methods: {
            toggleTab: function (tab, index) {
                this.currentTab = tab
//        切换class
                this.flag = index
            },
            clickToUp () {
                this.currentTab = 'ipoint'
                this.flag = 2
            },
            logOut () {
                if (confirm(this.$t('user_center_exit_the_login'))) {
                    this.Local.unset('users')
                    this.$router.replace('/')
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/common";
    @import "../../scss/personal/personal";
</style>



// WEBPACK FOOTER //
// Personal.vue?159bd7ed